import { useContext, useEffect } from "react";
import {
  Box,
  Divider,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { UserContext } from "src/Utils/Context/UserContext";

const PAGES = [
  { label: "Account Requests", path: "account-requests" },
  { label: "Organizations", path: "organizations" },
  { label: "Subscriptions", path: "subscriptions" },
  { label: "Payments", path: "payments" },
  { label: "Permissions", path: "permissions" },
  { label: "Capabilities", path: "capabilities" },
  { label: "Feature Switches", path: "feature-switches" },
  { label: "Delete Staff", path: "delete-staff" },
  { label: "Bulk Create Restaurants", path: "bulk-create-restaurants" },
  { label: "Bulk Create Menus", path: "bulk-create-menus" },
];

const AdminControlPanel = () => {
  const { user, isLoading } = useContext(UserContext);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (isLoading) return;
    if (!user?.admin) {
      navigate("/login", { replace: true });
    }
  }, [isLoading, user, navigate]);

  return (
    <Box display="flex" flexDirection="column" width="100%" gap={3}>
      <Box
        sx={{
          borderBottom: "1px solid",
          borderColor: "divider",
          pb: 2,
        }}
      >
        <Typography variant="overline" color="text.secondary" sx={{ px: 1 }}>
          Admin Control Panel
        </Typography>
        <Divider sx={{ mb: 1 }} />
        <List
          disablePadding
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          {PAGES.map((page) => {
            const active = pathname.includes(page.path);
            return (
              <ListItemButton
                key={page.path}
                selected={active}
                onClick={() => navigate(page.path)}
                sx={{ borderRadius: 1, width: "auto" }}
              >
                <ListItemText
                  primary={page.label}
                  primaryTypographyProps={{ fontSize: 14, textAlign: "center" }}
                />
              </ListItemButton>
            );
          })}
        </List>
      </Box>
      <Box flex={1}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default AdminControlPanel;
